import { render, staticRenderFns } from "./ModalLabelProducts.vue?vue&type=template&id=5a6e4e38&lang=pug&"
import script from "./ModalLabelProducts.vue?vue&type=script&lang=js&"
export * from "./ModalLabelProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports